import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;

  form {
    max-width: 500px;
  }
`;

const PageHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 2.4rem;
`;

const Lead = styled.p`
  font-size: 1.5rem;
  line-height: 1.5;
  color: var(--ink-soft);
  max-width: 60ch;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
  margin-bottom: 1.2rem;

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const Headline = styled.h2`
  font-size: 2rem;
  margin: 2rem 0;
  user-select: none;
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
`;

const Text = styled.p`
  display: inline-block;
`;

const CopyButton = styled.button`
  border: 1px solid var(--border);
  border-radius: var(--r-pill);
  background-color: var(--surface-2);
  color: var(--ink-soft);
  margin-left: 1rem;
  padding: 0 1.2rem;
  height: 3rem;
  font-size: 1.25rem;
  font-weight: 600;
  user-select: none;
  transition: background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);

  :hover {
    background-color: var(--accent-tint);
    border-color: var(--accent);
    color: var(--accent-deep);
  }
`;

const IndicationItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.8rem 0;
  background-color: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  padding: 1.6rem 2rem;

  p {
    padding: 0.3rem 0;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const IndicationItemTextContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  justify-content: center;
`;

const IndicationItemButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export {
  Actions,
  Container,
  Lead,
  PageHeader,
  Text,
  modalStyles,
  ButtonsContainer,
  Headline,
  CopyButton,
  IndicationItem,
  IndicationItemButtonsContainer,
  IndicationItemTextContainer,
};
